
import { useState } from 'react';

export const useContentGeneration = () => {
  const [generatedContent, setGeneratedContent] = useState<string>('');
  const [blogTitle, setBlogTitle] = useState<string>('');
  const [blogKeywords, setBlogKeywords] = useState<string>('');
  
  const handleBlogGenerated = (content: string, topic: string, keywords: string) => {
    setGeneratedContent(content);
    setBlogTitle(topic);
    setBlogKeywords(keywords);
  };

  return {
    generatedContent,
    blogTitle,
    blogKeywords,
    handleBlogGenerated
  };
};
